window.Branch = window.Branch || {};
window.Branch.functions = window.Branch.functions || {};

window.Branch.functions.getStyle = function(el, styleProp) {
    var value, defaultView = (el.ownerDocument || document).defaultView;
    if (defaultView && defaultView.getComputedStyle) {
        styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
        return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    } else if (el.currentStyle) { // IE
        styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
            return letter.toUpperCase();
        });
        value = el.currentStyle[styleProp];
        if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
            return (function(value) {
                var oldLeft = el.style.left,
                    oldRsLeft = el.runtimeStyle.left;
                el.runtimeStyle.left = el.currentStyle.left;
                el.style.left = value || 0;
                value = el.style.pixelLeft + "px";
                el.style.left = oldLeft;
                el.runtimeStyle.left = oldRsLeft;
                return value;
            })(value);
        }
        return value;
    }
}

/* Function that returns a srcset when passed an image URL */
window.Branch.functions.returnSrcSet = function(productImageUrl, cutOff) {
  let returnedSrcSet;
  if(productImageUrl.includes('?v=')){
    returnedSrcSet = `${productImageUrl}&width=90 90w, ${productImageUrl}&width=180 180w, ${productImageUrl}&width=360 360w, ${productImageUrl}&width=540 540w, ${productImageUrl}&width=720 720w, ${productImageUrl}&width=900 900w, ${productImageUrl}&width=1080 1080w, ${productImageUrl}&width=1280 1280w, ${productImageUrl}&width=1440 1440w`;
  } else {
    returnedSrcSet = `${productImageUrl}?width=90 90w, ${productImageUrl}?width=180 180w, ${productImageUrl}?width=360 360w, ${productImageUrl}?width=540 540w, ${productImageUrl}?width=720 720w, ${productImageUrl}?width=900 900w, ${productImageUrl}?width=1080 1080w, ${productImageUrl}?width=1280 1280w, ${productImageUrl}?width=1440 1440w`;
  }
  if(cutOff) {
    if(cutOff == 90 || cutOff == 180 || cutOff == 360 || cutOff == 540 || cutOff == 720 || cutOff == 900 || cutOff == 1080 || cutOff == 1280 || cutOff == 1440){
      let sizesArray = [90, 180, 360, 540, 720, 900, 1080, 1280, 1440];
      let sizesIndex = sizesArray.indexOf(cutOff);
      let newCutOff = sizesArray[sizesIndex + 1] || 1440; 
      const entries = returnedSrcSet.split(',');
      const cutOffIndex = entries.findIndex(src => src.includes(`width=${newCutOff}`));
      
      if (cutOffIndex !== -1) {
        returnedSrcSet = entries.slice(0, cutOffIndex).join(', ');
      }
    }
  }
  return returnedSrcSet;
}

/* Function that returns a string it's passed with the first letter of each word capitalized */
window.Branch.functions.capitalizeWords = function(str) {
  return str.split(' ').map(word => {
      if (word === word.toUpperCase()) {
          return word.charAt(0) + word.slice(1).toLowerCase();
      }
      return word;
  }).join(' ');
}

window.Branch.functions.isTouchDevice = function() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

window.Branch.functions.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    images.each(function(){
      var img = new Image();
      img.onload = loadFunction;
      img.onerror = loadFunction;
      if($(this).attr('src')){
        img.src = $(this).attr('src');
      }
      if($(this).attr('srcset')){
        img.srcset = $(this).attr('srcset');
      }
    });
  };

  window.Branch.functions.detectWrap = function(items) {
    var wrappedItems = [];
    var prevItem = {};
    var currItem = {};
    
    for (var i = 0; i < items.length; i++) {
      currItem = items[i].getBoundingClientRect();
      if (prevItem && prevItem.top < currItem.top) {
        wrappedItems.push(items[i]);
      }
      prevItem = currItem;
    };

    var wrapped = wrappedItems.length > 0 ? true : false;

    return wrapped;
  }

  window.Branch.functions.fixBody = function(type) {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    if(type == "fix"){
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      document.body.setAttribute('data-fixed', true)
    } else {
      document.body.removeAttribute('data-fixed')
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.removeProperty('width');
      // window.scrollTo({left: 0, top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
    }
  }

  window.Branch.functions.returnWindowWidth = function(){
    var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
    return width
  }
  
  window.Branch.functions.returnWindowHeight = function(){
    var height = window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;
    return height
  }

  window.Branch.functions.numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

window.Branch.functions.stripVariantText = function(string, variantTextReplacementMetafield){
  let strippedString = string.replaceAll(' vegan leather', '').replaceAll(' Vegan Leather', '');
  if(variantTextReplacementMetafield){
    let downcaseString = strippedString.toLowerCase();
    variantTextReplacementMetafield.forEach((word) => {
      downcaseString = downcaseString.replaceAll(word, '')
    });
    strippedString = downcaseString.trim().replace(/\b\w/g, char => char.toUpperCase());
  }
  return strippedString;
}

window.Branch.functions.returnSingleSrc = function(type, url, width){
  let singleSrc = '';
  let urlTemp = url;

  if(type == 'srcset'){
    urlTemp = url.split(',')[0].trim().split(' ')[0];
  }

  if(urlTemp.includes('&width')){
    urlTemp = urlTemp.split('&width')[0]
  } else if (urlTemp.includes('?width')){
    urlTemp = urlTemp.split('?width')[0]
  }

  if(urlTemp.includes('?v=')){
    urlTemp = `${urlTemp}&width=${width}`
  } else {
    urlTemp = `${urlTemp}?width=${width}`
  }
  singleSrc = urlTemp;

  return singleSrc;
}

window.Branch.functions.debounce = function(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), wait);
  };
}

window.Branch.functions.addEventListenerWithArg = function(element, event, handler, arg) {
  const listener = function(e) {
    handler(e, arg);
  };
  element.addEventListener(event, listener);

  return listener;
}

window.Branch.functions.returnCookieURL= function(cookieName){
  let cookieUrl = document.cookie
  .split("; ")
  .find((row) => row.startsWith(`${cookieName}=`))
  ?.split("=")[1]; 
  let url = "/"

  if(cookieUrl !== undefined && cookieUrl !== null && cookieUrl !== ''){
      url = cookieUrl;
  }

  return url
}

window.Branch.functions.getElementWithClass = function(event, className) {
  const target = event.target;

  if (target.classList.contains(className)) {
      return target;
  }

  let currentElement = target;
  while (currentElement.parentElement) {
      currentElement = currentElement.parentElement;
      if (currentElement.classList.contains(className)) {
          return currentElement;
      }
  }

  const matchingChild = target.querySelector(`.${className}`);
  if (matchingChild) {
      return matchingChild;
  }

  return null;
}

window.Branch.functions.isElementVisibleOrBelow = function(selector) {
  const element = document.querySelector(selector);
    if (!element) {
        return false; // Element doesn't exist
    }

    

    const rect = element.getBoundingClientRect();
    return (
        rect.bottom > 0 // Element is either within or below the viewport
    );
};

window.Branch.functions.isElementPartiallyOffScreen = function(selector) {
  const element = document.querySelector(selector);
  if (!element) {
      console.error(`Element with selector ${selector} not found`);
      return;
  }
  
  const rect = element.getBoundingClientRect();
  
  const isPartiallyOffScreen = (
      rect.top < 0 || 
      rect.left < 0 || 
      rect.bottom > window.innerHeight || 
      rect.right > window.innerWidth 
  );
  
  return isPartiallyOffScreen;
}

window.Branch.functions.defineInitFunctionSafely = function(functionName, func) {
  // Check if the function is already defined in the global scope
  if (typeof window[functionName] === "function") {
    console.warn(`Function "${functionName}" is already defined. New function not initialized.`);
    return;
  }

  // Flag to ensure the function only executes once
  let hasExecuted = false;

  // Define the new function
  window[functionName] = function (...args) {
      if (hasExecuted) {
          console.warn(`Function "${functionName}" has already been executed.`);
          return;
      }
      hasExecuted = true;
      func(...args);
  };
}

window.Branch.functions.capitalizeFirstLetter = function (val) {
  val = String(val);
  if (!val) return val; // Handle empty strings
  return val.charAt(0).toUpperCase() + val.slice(1);
};

window.Branch.functions.updateVariantParam = function(url, name, value) {
  const baseUrl = window.location.origin;
  if (!url.startsWith(baseUrl)) {
    url = baseUrl + url;
  }
  const urlObj = new URL(url); 
  urlObj.searchParams.set(name, value); 
  return urlObj.toString();
}

var discountCodeData = document.querySelector('#discount-code-data') ? JSON.parse(document.querySelector('#discount-code-data').innerText) : {};

window.Branch.functions.returnSalesTagText = function(salesTag, type, origin){
  let salesTagText = '';

  if(type != 'fromHandle' && salesTag.getAttribute('data-sale-text') != undefined && salesTag.getAttribute('data-sale-text') != ""){
    salesTagText = salesTag.getAttribute('data-sale-text');
  } else if(discountCodeData){
    let productHandle = type == 'fromHandle' ? salesTag : salesTag.getAttribute('data-product-handle');
    if(discountCodeData.active_campaign_1_is_active && discountCodeData.active_campaign_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.active_campaign_1_amount != undefined && (discountCodeData.active_campaign_1_amount > 0 || discountCodeData.active_campaign_1_discount_type === 'No discount actually applied')){
      // Suppress the auto "Save X%" badge when strike-through pricing is disabled, or for a
      // tiered campaign (the flat amount is meaningless there). Merchandised label overrides below still show.
      if(!discountCodeData.active_campaign_1_disable_strike_through_pricing && discountCodeData.active_campaign_1_discount_type !== 'Tiered product discount'){
        salesTagText = `Save ${discountCodeData.active_campaign_1_amount}%`;
      }
      if(discountCodeData.discount_code_1_special_swatch_text != "" && origin == 'sale-swatch'){
        salesTagText = discountCodeData.discount_code_1_special_swatch_text;
      }
      else if(discountCodeData.discount_code_1_special_pre_order_swatch_text != "" && origin == 'pre-order-swatch'){
        salesTagText = discountCodeData.discount_code_1_special_pre_order_swatch_text;
      }
      else if(discountCodeData.discount_code_1_special_swatch_text != "" && origin == 'pre-order-swatch-tooltip'){
        salesTagText = decodeURIComponent(discountCodeData.discount_code_1_special_pre_order_swatch_tooltip_text.replace(/\+/g, " "));
      }
    } else if(discountCodeData.active_campaign_2_is_active && discountCodeData.active_campaign_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.active_campaign_2_amount != undefined && (discountCodeData.active_campaign_2_amount > 0 || discountCodeData.active_campaign_2_discount_type === 'No discount actually applied')){
      // Suppress the auto "Save X%" badge when strike-through pricing is disabled, or for a
      // tiered campaign (the flat amount is meaningless there). Merchandised label overrides below still show.
      if(!discountCodeData.active_campaign_2_disable_strike_through_pricing && discountCodeData.active_campaign_2_discount_type !== 'Tiered product discount'){
        salesTagText = `Save ${discountCodeData.active_campaign_2_amount}%`;
      }
      if(discountCodeData.discount_code_2_special_swatch_text != "" && origin == 'sale-swatch'){
        salesTagText = discountCodeData.discount_code_2_special_swatch_text;
      }
      else if(discountCodeData.discount_code_2_special_pre_order_swatch_text != "" && origin == 'pre-order-swatch'){
        salesTagText = discountCodeData.discount_code_2_special_pre_order_swatch_text;
      }
      else if(discountCodeData.discount_code_2_special_swatch_text != "" && origin == 'pre-order-swatch-tooltip'){
        salesTagText = decodeURIComponent(discountCodeData.discount_code_2_special_pre_order_swatch_tooltip_text.replace(/\+/g, " "));
      }
    }
  }
  return salesTagText;
}

/*
 * Shared builder for the campaign "pre-order swatch" element (the label + optional HTML tooltip
 * dropdown). Single source of truth used by BOTH the PDP swatch (initPreOrderSwatch in
 * scripts_sections_main-product.js) and the bundle builder savings label (updatePriceElement in
 * scripts_snippets_bundle-builder-form.js) so the markup only needs to change in one place.
 *
 * Sets `preOrderSwatch.innerHTML` + the data-* fallback attributes on the passed element.
 * opts: { messageDesktop, messageMobile, tooltipText, useHtmlTooltip, tooltipHtml, promoStyling,
 *         swatchColor, applySentenceCase }
 */
window.Branch.functions.renderPreOrderSwatch = function(preOrderSwatch, opts){
  if(!preOrderSwatch) return;
  opts = opts || {};
  let messageDesktop = (opts.messageDesktop || '').replaceAll('<p>', '').replaceAll('</p>', '');
  let messageMobile = (opts.messageMobile || '').replaceAll('<p>', '').replaceAll('</p>', '');
  let tooltipText = opts.tooltipText || '';
  let useHtmlTooltip = !!(opts.useHtmlTooltip && opts.tooltipHtml);
  let tooltipHtml = opts.tooltipHtml || '';

  let questionIconSvg = `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM5.50098 8.17578C5.31784 8.17579 5.17526 8.2261 5.07422 8.32715C4.97958 8.42187 4.93263 8.5611 4.93262 8.74414V8.90527C4.93262 9.08843 4.97949 9.23098 5.07422 9.33203C5.17526 9.42676 5.31784 9.47363 5.50098 9.47363H5.62402C5.80704 9.47363 5.94628 9.42662 6.04102 9.33203C6.14207 9.23098 6.19238 9.08843 6.19238 8.90527V8.74414C6.19237 8.56103 6.14205 8.42187 6.04102 8.32715C5.94628 8.22618 5.80711 8.17578 5.62402 8.17578H5.50098ZM5.73828 2.46289C5.39102 2.46289 5.06232 2.52956 4.75293 2.66211C4.44982 2.78841 4.18438 2.96851 3.95703 3.20215C3.82447 3.33471 3.76382 3.4799 3.77637 3.6377C3.789 3.79559 3.87186 3.93124 4.02344 4.04492C4.16863 4.15222 4.31034 4.18723 4.44922 4.14941C4.59448 4.1052 4.71828 4.03862 4.81934 3.9502C4.94549 3.84304 5.08401 3.75742 5.23535 3.69434C5.39325 3.63118 5.56144 3.59961 5.73828 3.59961C5.96535 3.59967 6.16709 3.64762 6.34375 3.74219C6.52691 3.83692 6.66946 3.96665 6.77051 4.13086C6.87777 4.29502 6.93164 4.48458 6.93164 4.69922C6.9316 4.98963 6.86847 5.2236 6.74219 5.40039C6.6222 5.57713 6.45737 5.70601 6.24902 5.78809C6.04079 5.86377 5.80749 5.9023 5.54883 5.90234C5.38462 5.90234 5.24799 5.95859 5.14062 6.07227C5.03326 6.17963 4.97949 6.31626 4.97949 6.48047V7.2002C4.97953 7.36432 5.03331 7.50355 5.14062 7.61719C5.24799 7.72456 5.38462 7.77832 5.54883 7.77832C5.71283 7.77822 5.84879 7.72445 5.95605 7.61719C6.06338 7.50354 6.11715 7.36433 6.11719 7.2002V6.84961C6.11719 6.83715 6.11983 6.8276 6.12598 6.82129C6.13861 6.81497 6.15143 6.80807 6.16406 6.80176C6.43552 6.75757 6.68482 6.68496 6.91211 6.58398C7.14579 6.47662 7.34803 6.33752 7.51855 6.16699C7.69539 5.99015 7.83202 5.78198 7.92676 5.54199C8.0214 5.29581 8.06833 5.01479 8.06836 4.69922C8.06836 4.2762 7.96415 3.89716 7.75586 3.5625C7.54744 3.22776 7.26579 2.96239 6.91211 2.7666C6.56491 2.56466 6.1738 2.46296 5.73828 2.46289Z" fill="white"/></svg>`;

  let tooltipIconHTML = '';
  let tooltipDropdownHTML = '';
  if(useHtmlTooltip){
    tooltipIconHTML = `<button type="button" class="utility-bar__tooltip-trigger pre-order-swatch__tooltip-trigger" aria-expanded="false" aria-label="More information">${questionIconSvg}</button>`;
    tooltipDropdownHTML = `<div class="utility-bar__tooltip-dropdown" data-visible="false">${tooltipHtml}</div>`;
  } else {
    tooltipIconHTML = `<svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-tooltip" viewBox="0 0 18 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26191 16.8867C14.0714 16.8867 17.9702 13.1436 17.9702 8.52635C17.9702 3.90907 14.0714 0.166016 9.26191 0.166016C4.45243 0.166016 0.553574 3.90907 0.553574 8.52635C0.553574 13.1436 4.45243 16.8867 9.26191 16.8867ZM8.01518 8.62759C7.85935 8.77719 7.78143 8.9664 7.78143 9.19521V10.1984C7.78143 10.4273 7.85935 10.6209 8.01518 10.7793C8.17101 10.9289 8.3681 11.0037 8.60643 11.0037C8.84476 11.0037 9.04185 10.9289 9.19768 10.7793C9.35351 10.6209 9.43143 10.4273 9.43143 10.1984V9.71003C9.43143 9.69243 9.43601 9.67923 9.44518 9.67043L9.50018 9.64403C9.89435 9.58242 10.2564 9.48122 10.5864 9.34042C10.9256 9.19081 11.2189 8.9972 11.4664 8.75959C11.7231 8.51318 11.9202 8.22277 12.0577 7.88836C12.1952 7.54514 12.2639 7.15353 12.2639 6.71351C12.2639 6.12388 12.1127 5.59586 11.8102 5.12944C11.5077 4.66302 11.0998 4.29341 10.5864 4.0206C10.0823 3.73899 9.51393 3.59818 8.88143 3.59818C8.37726 3.59818 7.9006 3.69059 7.45143 3.87539C7.01143 4.0514 6.62643 4.30221 6.29643 4.62782C6.10393 4.81263 6.01685 5.01504 6.03518 5.23505C6.05351 5.45506 6.17268 5.64426 6.39268 5.80267C6.60351 5.95228 6.80976 6.00068 7.01143 5.94788C7.22226 5.88627 7.40101 5.79387 7.54768 5.67067C7.73101 5.52106 7.93268 5.40226 8.15268 5.31425C8.38185 5.22625 8.62476 5.18225 8.88143 5.18225C9.21143 5.18225 9.50476 5.24825 9.76143 5.38025C10.0273 5.51226 10.2335 5.69267 10.3802 5.92148C10.536 6.15029 10.6139 6.4143 10.6139 6.71351C10.6139 7.11832 10.5223 7.44394 10.3389 7.69035C10.1648 7.93676 9.92643 8.11717 9.62393 8.23157C9.32143 8.33717 8.98226 8.38998 8.60643 8.38998C8.3681 8.38998 8.17101 8.46918 8.01518 8.62759ZM7.91893 13.1686C8.0656 13.3006 8.27185 13.3666 8.53768 13.3666H8.71643C8.98226 13.3666 9.18393 13.3006 9.32143 13.1686C9.4681 13.0278 9.54143 12.8298 9.54143 12.5745V12.3501C9.54143 12.0949 9.4681 11.9013 9.32143 11.7693C9.18393 11.6285 8.98226 11.5581 8.71643 11.5581H8.53768C8.27185 11.5581 8.0656 11.6285 7.91893 11.7693C7.78143 11.9013 7.71268 12.0949 7.71268 12.3501V12.5745C7.71268 12.8298 7.78143 13.0278 7.91893 13.1686Z" fill="white"></path></svg>`;
  }

  preOrderSwatch.innerHTML = `<p>
                                <span ${useHtmlTooltip ? '' : `data-tooltip="${tooltipText}"`}${opts.promoStyling ? ' active-campaign-promo-style="true" active-campaign-promo-type="pre_order_swatches"' : ''}${opts.swatchColor ? ' data-display-active-campaign-swatch-background="true" ' : ''}>
                                    <span class="pre-order-swatch__desktop">
                                        ${messageDesktop}
                                    </span>
                                    <span class="pre-order-swatch__mobile">
                                        ${messageMobile}
                                    </span>
                                    ${tooltipIconHTML}
                                </span>
                            </p>${tooltipDropdownHTML}`;
  preOrderSwatch.setAttribute('data-initialized', true);
  preOrderSwatch.setAttribute('data-display', true);
  preOrderSwatch.setAttribute('data-tooltip-fallback', tooltipText);
  preOrderSwatch.setAttribute('data-text-fallback', messageDesktop.replaceAll('<span data-sale="test">', '').replaceAll('</span>', ''));
  preOrderSwatch.setAttribute('data-text-fallback-mobile', messageMobile);
  if(useHtmlTooltip){
    preOrderSwatch.setAttribute('data-html-tooltip', 'true');
    // Remove legacy data-tooltip to prevent the CSS pseudo-element tooltip from showing.
    let innerSpan = preOrderSwatch.querySelector('span');
    if(innerSpan) innerSpan.removeAttribute('data-tooltip');
  }
  if(opts.applySentenceCase && preOrderSwatch.getAttribute('data-text-transform') == 'sentencecase'){
    preOrderSwatch.querySelectorAll('.pre-order-swatch__desktop, .pre-order-swatch__mobile').forEach((textEl) => {
      const walker = document.createTreeWalker(textEl, NodeFilter.SHOW_TEXT, null);
      let firstDone = false;
      let node;
      while((node = walker.nextNode())){
        let text = node.nodeValue.toLowerCase();
        if(!firstDone){
          const match = text.match(/\S/);
          if(match){
            const i = match.index;
            text = text.slice(0, i) + text.charAt(i).toUpperCase() + text.slice(i + 1);
            firstDone = true;
          }
        }
        node.nodeValue = text;
      }
    });
  }
}

/*
 * Looks up a product's active-campaign metadata. Used by the smart-search
 * results renderer (scripts_sections_toggle-header.js:2140) and other call
 * sites to read swatch background color / promo-styling overrides driven by
 * the active-campaigns metaobject.
 *
 * Returns the requested field for whichever active campaign the product
 * belongs to, or `undefined` if no campaign matches. When the campaign data
 * fields are absent from `discountCodeData` (older branches that haven't
 * migrated to the campaigns schema yet), the `&&` chain short-circuits and
 * this safely returns `undefined`.
 *
 * @param {Element|string} swatchEl  Element with [data-product-handle], or
 *                                   a raw product handle when `type === 'fromHandle'`.
 * @param {'fromHandle'|string} type If `'fromHandle'`, `swatchEl` is treated
 *                                   as a string handle instead of an element.
 * @param {'swatch-color'|'promo-styling'} origin  Which field to return.
 */
window.Branch.functions.returnSpecificActiveCampaignData = function(swatchEl, type, origin){
  let dataToReturn;

  if(discountCodeData){
    let productHandle = type == 'fromHandle' ? swatchEl : swatchEl.getAttribute('data-product-handle');
    if(discountCodeData.active_campaign_1_is_active && discountCodeData.active_campaign_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.active_campaign_1_swatch_default_color != undefined && discountCodeData.active_campaign_1_swatch_default_color != ''){
      if(origin == 'swatch-color'){
        dataToReturn = discountCodeData.active_campaign_1_swatch_default_color;
      } else if(origin == 'promo-styling'){
        dataToReturn = discountCodeData.active_campaign_1_enable_promo_styling;
      }
    } else if(discountCodeData.active_campaign_2_is_active && discountCodeData.active_campaign_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.active_campaign_2_swatch_default_color != undefined && discountCodeData.active_campaign_2_swatch_default_color != ''){
      if(origin == 'swatch-color'){
        dataToReturn = discountCodeData.active_campaign_2_swatch_default_color;
      } else if(origin == 'promo-styling'){
        dataToReturn = discountCodeData.active_campaign_2_enable_promo_styling;
      }
    }
  }

  if(dataToReturn === '' || dataToReturn === undefined) return undefined;
  return dataToReturn;
}

/*
 * For a "Tiered product discount" campaign, returns the discount a single unit of the
 * product would receive on its own (i.e. as if there were just one in the cart): the tier
 * is selected from that one unit's price, then capped at maxDiscountTotal. Used to
 * preview the price on non-cart surfaces (PDP, tiles, etc). Returns { percentage, message }
 * or null when the campaign isn't tiered / no tier is met / config is invalid.
 *
 * NOTE: maxDiscountTotal (JSON key `maxDiscountPerProduct`) is the cap on the combined
 * discount across the whole order. For a single unit previewed on its own the order IS that
 * one unit, so the cap applies directly to it — the math is identical to the cart loop.
 *
 * @param {number} priceCents  the single-unit price in cents
 * @param {number} campaignIndex  1 or 2
 */
/*
 * Parse a "Tiered product discount" campaign's `discount_special_merchandizing` config.
 * Returns { config, tiers, maxDiscountTotal } or null when the campaign isn't tiered / the JSON
 * is missing or unparseable. Single source of truth for the tiered-config shape so the PDP,
 * cart, and bundle consumers can't drift on key names / decoding.
 */
window.Branch.functions.parseTieredConfig = function(campaignIndex){
  if(typeof discountCodeData === 'undefined' || !discountCodeData) return null;
  if(discountCodeData[`active_campaign_${campaignIndex}_discount_type`] !== 'Tiered product discount') return null;
  let raw = discountCodeData[`active_campaign_${campaignIndex}_discount_special_merchandizing`];
  if(!raw) return null;
  let config;
  try { config = JSON.parse(decodeURIComponent(raw.replace(/\+/g, ' '))); } catch(e){ return null; }
  let tiers = Array.isArray(config.discountData) ? config.discountData : (config.discountData ? [config.discountData] : []);
  let maxDiscountTotal = (config.maxDiscountPerProduct && config.maxDiscountPerProduct > 0) ? config.maxDiscountPerProduct : 0;
  return { config: config, tiers: tiers, maxDiscountTotal: maxDiscountTotal };
}

/*
 * Given the parsed tiers, the order-wide cap, and a spend total (cents), pick the highest tier the
 * spend meets and apply the cap. The cap (`maxDiscountPerProduct`, order-wide despite the name) is
 * honoured by lowering the per-line % uniformly to (cap / spend) — the equivalence the cart relies
 * on. Returns { tier, tierPercentage, effectivePercentage, capBinds } or null when no tier is met.
 * The Function works in major currency units (dollars); theme prices are in cents.
 */
window.Branch.functions.selectTier = function(tiers, maxDiscountTotal, spendCents){
  if(!Array.isArray(tiers) || !tiers.length || !(spendCents > 0)) return null;
  let spendMajor = spendCents / 100;
  let tier = tiers
    .filter((t) => t && spendMajor >= t.threshold)
    .reduce((best, t) => (!best || t.threshold > best.threshold ? t : best), null);
  if(!tier || !tier.discount_amount || tier.discount_amount <= 0) return null;
  let tierPercentage = tier.discount_amount;
  let effectivePercentage = tierPercentage;
  let capBinds = maxDiscountTotal > 0 && (tierPercentage / 100) * spendMajor > maxDiscountTotal;
  if(capBinds) effectivePercentage = (maxDiscountTotal / spendMajor) * 100;
  return { tier: tier, tierPercentage: tierPercentage, effectivePercentage: effectivePercentage, capBinds: capBinds };
}

window.Branch.functions.tieredSingleItemDiscount = function(priceCents, campaignIndex){
  let parsed = window.Branch.functions.parseTieredConfig(campaignIndex);
  if(!parsed) return null;
  let selected = window.Branch.functions.selectTier(parsed.tiers, parsed.maxDiscountTotal, priceCents);
  if(!selected) return null;
  return { percentage: selected.effectivePercentage, message: selected.tier.discount_message || '' };
}

window.Branch.functions.returnBundleTieredDiscount = function(lineItems){
  if(typeof discountCodeData === 'undefined' || !discountCodeData || !Array.isArray(lineItems)) return null;
  for(let i = 1; i <= 2; i++){
    if(!discountCodeData[`active_campaign_${i}_is_active`]) continue;
    if(discountCodeData[`active_campaign_${i}_discount_type`] !== 'Tiered product discount') continue;
    let handles = (discountCodeData[`active_campaign_${i}_product_handles`] || '').replaceAll(' ', '').split(',').filter(Boolean);
    if(!handles.length) continue;
    let eligibleHandles = new Set(handles);
    let covered = lineItems.filter((li) => li && eligibleHandles.has(li.handle));
    if(!covered.length) continue; // this campaign doesn't touch the bundle — try the next one
    // First covering active tiered campaign wins (campaign-1 precedence).
    let parsed = window.Branch.functions.parseTieredConfig(i);
    let result = {
      campaignIndex: i,
      eligibleHandles: eligibleHandles,
      percentage: 0,
      message: '',
      campaignMessage: discountCodeData[`active_campaign_${i}_message`] || '',
      // Campaign's Sale-swatch label override (e.g. "Save up to 18%") for the covering campaign,
      // so bundle surfaces can show it when a constituent qualifies.
      bundleSwatchText: discountCodeData[`active_campaign_${i}_bundle_builder_discount_swatch_text`] || discountCodeData[`discount_code_${i}_special_swatch_text`] || '',
      bundleDiscountsSwitchedOff: !!(parsed && parsed.config && parsed.config.bundleDiscountsSwitchedOff)
    };
    // disable_strike_through_pricing: eligible, but show full price (no campaign discount).
    if(discountCodeData[`active_campaign_${i}_disable_strike_through_pricing`]) return result;
    if(!parsed) return result;
    // Tier from the COMBINED eligible spend (cents) across the bundle's covered lines.
    let totalSpendCents = covered.reduce((sum, li) => sum + (parseInt(li.priceCents) || 0), 0);
    let selected = window.Branch.functions.selectTier(parsed.tiers, parsed.maxDiscountTotal, totalSpendCents);
    if(!selected) return result;
    result.percentage = selected.effectivePercentage > 0 ? selected.effectivePercentage : 0;
    result.message = selected.tier.discount_message || '';
    return result;
  }
  return null;
}

window.Branch.functions.returnDiscountCodeUpdates = function(currentPrice, originalPrice, discountAmount, discountMessage, productHandle){
  let discountCodeLimit = 999999999999;
  let hidePdpBadgeMessage = false;
  let overridePdpTooltip = false;
  let pdpTooltipHtml = '';
  let activeCampaignPromoStylingEnabled = false;
  let activeCampaignSwatchColorEnabled = false;
  if (discountCodeData.active_campaign_1_is_active && discountCodeData.active_campaign_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle)) {
    if(originalPrice == null || originalPrice == 0){originalPrice = currentPrice};
    // When strike-through pricing is disabled, leave the price at full and suppress the discount message; merchandised label/tooltip overrides and promo styling below are still applied.
    if(!discountCodeData.active_campaign_1_disable_strike_through_pricing){
      if(discountCodeData.active_campaign_1_discount_type === 'Tiered product discount'){
        // Non-cart surfaces preview the discount this item would get as a single unit.
        let tiered = window.Branch.functions.tieredSingleItemDiscount(currentPrice, 1);
        if(tiered){
          discountAmount = tiered.percentage;
          currentPrice = currentPrice * (1 - tiered.percentage / 100);
          discountMessage = tiered.message || discountMessage;
        }
      } else {
        discountAmount = discountCodeData.active_campaign_1_amount;
        currentPrice = currentPrice * (1 - discountAmount / 100);
        discountMessage = discountCodeData.active_campaign_1_message;
      }
    }
    discountCodeLimit = discountCodeData.active_campaign_1_limit;
    hidePdpBadgeMessage = discountCodeData.discount_code_1_hide_message_from_pdp_badge || false;
    overridePdpTooltip = discountCodeData.discount_code_1_override_pdp_tooltip || false;
    pdpTooltipHtml = discountCodeData.discount_code_1_special_pre_order_swatch_tooltip_text ? decodeURIComponent(discountCodeData.discount_code_1_special_pre_order_swatch_tooltip_text.replace(/\+/g, " ")) : '';
    activeCampaignPromoStylingEnabled = discountCodeData.active_campaign_1_enable_promo_styling || false;
    activeCampaignSwatchColorEnabled = discountCodeData.active_campaign_1_swatch_default_color ? true : false;
  } else if (discountCodeData.active_campaign_2_is_active && discountCodeData.active_campaign_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle)) {
    if(originalPrice == null || originalPrice == 0){originalPrice = currentPrice};
    // When strike-through pricing is disabled, leave the price at full and suppress the discount message; merchandised label/tooltip overrides and promo styling below are still applied.
    if(!discountCodeData.active_campaign_2_disable_strike_through_pricing){
      if(discountCodeData.active_campaign_2_discount_type === 'Tiered product discount'){
        // Non-cart surfaces preview the discount this item would get as a single unit.
        let tiered = window.Branch.functions.tieredSingleItemDiscount(currentPrice, 2);
        if(tiered){
          discountAmount = tiered.percentage;
          currentPrice = currentPrice * (1 - tiered.percentage / 100);
          discountMessage = tiered.message || discountMessage;
        }
      } else {
        discountAmount = discountCodeData.active_campaign_2_amount;
        currentPrice = currentPrice * (1 - discountAmount / 100);
        discountMessage = discountCodeData.active_campaign_2_message;
      }
    }
    discountCodeLimit = discountCodeData.active_campaign_2_limit;
    hidePdpBadgeMessage = discountCodeData.discount_code_2_hide_message_from_pdp_badge || false;
    overridePdpTooltip = discountCodeData.discount_code_2_override_pdp_tooltip || false;
    pdpTooltipHtml = discountCodeData.discount_code_2_special_pre_order_swatch_tooltip_text ? decodeURIComponent(discountCodeData.discount_code_2_special_pre_order_swatch_tooltip_text.replace(/\+/g, " ")) : '';
    activeCampaignPromoStylingEnabled = discountCodeData.active_campaign_2_enable_promo_styling || false;
    activeCampaignSwatchColorEnabled = discountCodeData.active_campaign_2_swatch_default_color ? true : false;
  }

  // OR-in the personalization winner so dynamically-updated pre-order swatches get the gradient on all product pages even when the campaign's promo styling is off (styling only; price/discount above untouched). See personalizations_trigger.liquid.
  if(!activeCampaignPromoStylingEnabled && window.Branch.personalization && window.Branch.personalization.promoStylingWins){ activeCampaignPromoStylingEnabled = true; }
  return {'currentPrice': parseInt(currentPrice), 'originalPrice': parseInt(originalPrice), 'discountAmount': discountAmount, 'discountMessage': discountMessage, 'discountCodeLimit': discountCodeLimit, 'hidePdpBadgeMessage': hidePdpBadgeMessage, 'overridePdpTooltip': overridePdpTooltip, 'pdpTooltipHtml': pdpTooltipHtml, 'activeCampaignPromoStylingEnabled': activeCampaignPromoStylingEnabled, 'activeCampaignSwatchColorEnabled': activeCampaignSwatchColorEnabled};
}

window.Branch.functions.truncateText = function (text, maxWidth, font = "16px Quicksand") {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.font = font;
  if (ctx.measureText(text).width <= maxWidth) return text;

  while (text.length && ctx.measureText(text + "...").width > maxWidth) 
      text = text.slice(0, -1);

  return text + "...";
}


window.Branch.functions.updateSideCartPricing = function(type){
  let topSelector = type == 'side-cart' ? '#side-cart' : (type == 'quiz-results' ? '.results-page .summary' : '#cart');
  let itemPriceSelector = type == 'quiz-results' ? '.item .price.igPrice' : '.item .price:not(.igPrice)';
  let itemPrices = document.querySelectorAll(`${topSelector} ${type == 'side-cart' ? '.cart-items form' : (type == 'quiz-results' ? '.items' : 'form .items')} ${itemPriceSelector}`);
  let cartTotalOriginalPrice = 0;
  let cartTotalDiscountedPrice = 0;
  let cartTotalDiscount = 0;
  let orderLevelDiscountTotal = 0;
  let orderLevelDiscountMessage = '';
  const perProductQuantities = {};
  document.querySelectorAll(`${topSelector} ${type == 'side-cart' ? '.cart-items' : '.items'} ${type == 'quiz-results' ? '' : 'form '}.item`).forEach(item => {
    const handle = item.getAttribute('data-product-handle');
    let quantity = 0;
    if (type == 'quiz-results') {
      const quantitySpan = item.querySelector('.quantity span');
      quantity = parseInt(quantitySpan?.textContent, 10) || 0;
    } else {
      const quantityInput = item.querySelector('.quantity-box input[type="number"]');
      quantity = parseInt(quantityInput?.value, 10) || 0;
    }
    if (!perProductQuantities[handle]) {perProductQuantities[handle] = 0};
    perProductQuantities[handle] += quantity;
  });

  // ---- Tiered product discount (side cart + cart page): replicate the checkout discount Function ----
  // A single tier % is selected from the TOTAL eligible spend, then applied per product and
  // capped at maxDiscountPerProduct. Mirrors assets-side of cartLinesDiscountsGenerateRun so
  // the displayed price matches what the Function will apply at checkout.
  // NOTE: the Function works in major currency units (e.g. 299.99) while the cart works in
  // cents, so cart amounts are divided by 100 before comparing thresholds / computing the cap.
  // Applies to the side cart and cart page (which share the line loop below) but not quiz-results.
  let tieredEligibleHandles = null;     // Set of handles covered by the active tiered campaign
  let tieredEffectivePctByHandle = {};  // handle -> capped effective % (absent => no discount)
  let tieredMessage = '';
  let tieredCapCents = 0;               // > 0 when the order-wide cap binds: exact total discount (cents) to distribute
  let tieredTotalSpendCents = 0;        // total eligible spend (cents), used to pro-rate the cap across lines
  let tieredEligibleLineCount = 0;      // number of eligible lines with spend (to find the last for the remainder)
  if(type != 'quiz-results' && typeof discountCodeData !== 'undefined' && discountCodeData){
    for(let i = 1; i <= 2; i++){
      if(!discountCodeData[`active_campaign_${i}_is_active`]) continue;
      let parsed = window.Branch.functions.parseTieredConfig(i);
      if(!parsed || !parsed.tiers.length) continue;
      // NOTE: `maxDiscountPerProduct` is the JSON key name but now caps the combined discount
      // across the WHOLE order (not per product), matching the discount Function.
      let maxDiscountTotal = parsed.maxDiscountTotal;
      let eligibleHandles = (discountCodeData[`active_campaign_${i}_product_handles`] || '').replaceAll(' ', '').split(',').filter(Boolean);
      if(!eligibleHandles.length) continue;

      // Pass 1: total eligible spend + per-product spend (cents), from the selling (deal) price.
      let totalSpendCents = 0;
      let spendByHandleCents = {};
      let eligibleLineCount = 0;
      itemPrices.forEach((itemPrice) => {
        let lineHandle = itemPrice.closest('.item').getAttribute('data-product-handle');
        if(!eligibleHandles.includes(lineHandle)) return;
        let dealEl = itemPrice.querySelector('.deal');
        let multiplier = parseInt(dealEl.getAttribute('data-quantity-multiplier')) || 1;
        let lineQty = parseInt(itemPrice.closest('.grid').querySelector('.quantity-box input[type="number"]').value) || 0;
        let lineSpend = lineQty * (parseInt(dealEl.getAttribute('data-price')) / multiplier);
        if(!lineSpend || lineSpend <= 0) return;
        totalSpendCents += lineSpend;
        spendByHandleCents[lineHandle] = (spendByHandleCents[lineHandle] || 0) + lineSpend;
        eligibleLineCount++;
      });
      if(totalSpendCents <= 0) continue;

      // Select the highest tier met by total eligible spend, with the order-wide cap applied as a
      // uniform per-line percentage (the Function distributes the cap proportionally). The cap and
      // tier math are shared with the PDP/bundle surfaces via selectTier so they can't drift.
      let selected = window.Branch.functions.selectTier(parsed.tiers, maxDiscountTotal, totalSpendCents);
      if(!selected) continue;
      let effectivePercentage = selected.effectivePercentage;
      let capBinds = selected.capBinds;
      if(effectivePercentage <= 0) continue;

      tieredEligibleHandles = new Set(eligibleHandles);
      tieredMessage = selected.tier.discount_message || '';
      for(let spendHandle in spendByHandleCents){
        if(spendByHandleCents[spendHandle] <= 0) continue;
        tieredEffectivePctByHandle[spendHandle] = effectivePercentage;
      }
      // When the cap binds, applying the % per line and rounding each independently makes the
      // summed discount drift a cent or two off the cap (e.g. $359.99 / $360.01). Carry the exact
      // cap (cents) + total spend so the line loop can distribute it pro-rata and put any rounding
      // remainder on the last eligible line, landing the total discount EXACTLY on the cap —
      // matching the Function's single fixed-amount approach.
      if(capBinds){
        tieredCapCents = Math.round(maxDiscountTotal * 100);
        tieredTotalSpendCents = totalSpendCents;
        tieredEligibleLineCount = eligibleLineCount;
      }
      break; // campaign 1 wins over campaign 2
    }
  }

  // Running allocation of the order-wide cap (cents) across eligible lines, used only when it binds.
  let tieredCapAllocatedCents = 0;
  let tieredCapLinesRemaining = tieredEligibleLineCount;

  itemPrices.forEach((itemPrice) => {
    if (type == 'quiz-results') {
      // Simplified handling for quiz results - just add discount message and retail price
      let discountDataScript = itemPrice.closest('.edit-item').querySelector('.discount-allocation-data');
      if (!discountDataScript) return;

      let discountData = JSON.parse(discountDataScript.innerText);
      let discountMessage = '';

      let currentPrice = parseInt(itemPrice.getAttribute('data-line-price'));
      let originalPrice = parseInt(itemPrice.getAttribute('data-original-price'));

      discountData.forEach((discountLine) => {
        if(discountLine.target_type == 'line_item' && discountLine.target_selection != 'all'){
          discountMessage = `<p> with <strong>'${discountLine.title}'</strong></p>`;
        }
      });

      // Show retail price if there's a discount
      if (originalPrice > currentPrice) {
        let moneySpan = itemPrice.querySelector('.money');
        if (moneySpan && !itemPrice.querySelector('.retail-price')) {
          let retailPriceHtml = `<span class="money retail-price" style="text-decoration: line-through; margin-right: 0.5em;opacity: .4;">${Shopify.formatMoney(originalPrice, Simplistic.formatMoney)}</span>`;
          moneySpan.insertAdjacentHTML('beforebegin', retailPriceHtml);
        }
      }

      let titleQttyPriceDiv = itemPrice.closest('.title-qtty-price');
      let parentContainer = itemPrice.closest('.item');
      if(discountMessage != '' && parentContainer && !parentContainer.querySelector('.cart-discount-code-message')){
        titleQttyPriceDiv.insertAdjacentHTML('afterend', `<div class="cart-discount-code-message">${discountMessage}</div>`);
      } else if(discountMessage != '' && parentContainer && parentContainer.querySelector('.cart-discount-code-message')) {
        parentContainer.querySelector('.cart-discount-code-message').innerHTML = discountMessage;
      }
      return;
    }

    // Original logic for side-cart and cart-page
    let currentQuantity =  parseInt(itemPrice.querySelector('.deal').getAttribute('data-quantity-multiplier'));
    let newQuantity = parseInt(itemPrice.closest('.grid').querySelector('.quantity-box input[type="number"').value);
    itemPrice.querySelector('.deal').setAttribute('data-quantity-multiplier', newQuantity)
    let currentPrice = newQuantity * (parseInt(itemPrice.querySelector('.deal').getAttribute('data-price')) / currentQuantity);
    let productHandle = itemPrice.closest('.item').getAttribute('data-product-handle');
    let originalCurrentPrice = currentPrice + 0;
    let previousPrice =  newQuantity * (parseInt(itemPrice.querySelector('.retail').getAttribute('data-price')) / currentQuantity);
    let compareAtDiscount = previousPrice > currentPrice ? previousPrice - currentPrice : 0;
    cartTotalDiscount = cartTotalDiscount + compareAtDiscount;
    let discountData = JSON.parse(itemPrice.querySelector('.discount-allocation-data').innerText);
    let discountAmount = 0;
    let discountMessage = '';

    if(previousPrice == 0){
      previousPrice = originalCurrentPrice;
    }

    const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, previousPrice, 0, '', productHandle);
    let codeCurrentPrice = codeDiscountData.currentPrice;
    let codeLimit = codeDiscountData.discountCodeLimit;


    let exceedsLimit = false;
    if(perProductQuantities[`${productHandle}`] > codeLimit){
      exceedsLimit = true;
    }

    discountData.forEach((discountLine) => {
      if(discountLine.target_type == 'line_item' && discountLine.target_selection != 'all'){
        currentPrice = currentPrice - discountLine.amount;
        discountAmount = discountAmount + discountLine.amount
        discountMessage = `<p> with <strong>'${discountLine.title}'</strong></p>`;
      } else if(discountLine.target_type == 'line_item' && discountLine.target_selection == 'all'){
        orderLevelDiscountTotal = orderLevelDiscountTotal + discountLine.amount;
        orderLevelDiscountMessage = discountLine.title;
      }
    })

    if(tieredEligibleHandles && tieredEligibleHandles.has(productHandle)){
      // Product is covered by the active tiered campaign: use the tiered discount and
      // never fall through to the flat code projection (a tiered-eligible product with no
      // tier met simply shows no campaign discount).
      let tieredCurrentPrice = null;
      if(tieredCapCents > 0 && originalCurrentPrice > 0 && tieredTotalSpendCents > 0){
        // Cap binds: distribute the EXACT cap pro-rata by line spend; the last eligible line takes
        // the remainder, so the summed discount lands exactly on the cap (no per-line rounding drift).
        tieredCapLinesRemaining--;
        let lineDiscount = tieredCapLinesRemaining <= 0
          ? tieredCapCents - tieredCapAllocatedCents
          : Math.round(originalCurrentPrice / tieredTotalSpendCents * tieredCapCents);
        tieredCapAllocatedCents += lineDiscount;
        tieredCurrentPrice = originalCurrentPrice - lineDiscount;
      } else {
        let tieredPct = tieredEffectivePctByHandle[productHandle];
        if(tieredPct && tieredPct > 0){
          tieredCurrentPrice = Math.round(originalCurrentPrice * (1 - tieredPct / 100));
        }
      }
      // Guard against originalCurrentPrice (the pre-discount price), NOT currentPrice. When the
      // campaign discount is an automatic discount already applied in the cart, `currentPrice` has
      // already been reduced by that discount's per-line allocation (rounded by Shopify), in the
      // discountData loop above. The theme's own pro-rata cap distribution rounds differently per
      // line, so comparing against the allocation-reduced currentPrice keeps the allocation value on
      // some lines and the tiered value on others — and the two no longer sum to the cap (surfacing
      // as e.g. $360.01). Comparing against originalCurrentPrice lets the tiered distribution fully
      // override per line so the summed campaign discount lands exactly on the cap.
      if(tieredCurrentPrice != null && tieredCurrentPrice < originalCurrentPrice){
        // The retail→deal (compare-at) saving was already added to cartTotalDiscount above, so the
        // campaign's contribution here is ONLY the deal→tiered reduction. Measure it off the deal
        // price (originalCurrentPrice), not retail (previousPrice): this keeps the summed campaign
        // saving exactly on the cap and avoids double-counting the compare-at portion in the
        // "You're saving" total.
        discountAmount = originalCurrentPrice - tieredCurrentPrice;
        currentPrice = tieredCurrentPrice;
        discountMessage = tieredMessage ? `<p>${tieredMessage}</p>` : discountMessage;
      }
    } else if(codeCurrentPrice < currentPrice && exceedsLimit == false){
      discountAmount = previousPrice - codeCurrentPrice;
      currentPrice = codeCurrentPrice;
      discountMessage = codeDiscountData.discountMessage;
    }

    itemPrice.querySelector('span[data-price="deal"]').innerHTML = Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')
    itemPrice.querySelector('.deal').setAttribute('data-price', originalCurrentPrice);

    if(previousPrice != 0 && currentPrice < previousPrice){
      itemPrice.querySelector('span[data-price="retail"]').innerHTML = Shopify.formatMoney(previousPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')
      itemPrice.querySelector('.retail').setAttribute('data-visible', 'true');
      itemPrice.querySelector('.retail').setAttribute('data-price', previousPrice);
    }

    let parentContainer = itemPrice.closest('.grid');
    if(discountMessage != '' && parentContainer && !parentContainer.querySelector('.cart-discount-code-message')){
      itemPrice.insertAdjacentHTML('afterend', `<div class="cart-discount-code-message">${discountMessage}</div>`);
    } else if(discountMessage != '' && parentContainer && parentContainer.querySelector('.cart-discount-code-message')) {
      parentContainer.querySelector('.cart-discount-code-message').innerHTML = discountMessage;
    }

    cartTotalOriginalPrice = cartTotalOriginalPrice + previousPrice;
    cartTotalDiscountedPrice = cartTotalDiscountedPrice + currentPrice;
    cartTotalDiscount = cartTotalDiscount + discountAmount;
  });

  let cartTotalContainer = document.querySelector(`${topSelector} .cart-subtotal`);

  if(orderLevelDiscountTotal > 0){
    cartTotalDiscountedPrice = cartTotalDiscountedPrice - orderLevelDiscountTotal;
    cartTotalDiscount = cartTotalDiscount + orderLevelDiscountTotal;
  }

  if(cartTotalContainer){cartTotalContainer.querySelector('.column.igSubtotal').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalDiscountedPrice, Simplistic.formatMoney)}</span>`;};

  if(cartTotalOriginalPrice > cartTotalDiscountedPrice){
    if(cartTotalContainer){
      cartTotalContainer.querySelector('.column.pre-tiered-discount-price').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalOriginalPrice, Simplistic.formatMoney)}</span>`;
      cartTotalContainer.querySelector('.column.pre-tiered-discount-price').setAttribute('data-display', 'true');
    }

    let cartSavingsMessage= document.querySelector(`${topSelector} .cart-subtotal-saving-message`);
    cartSavingsMessage.setAttribute('data-display', 'true');
    cartSavingsMessage.setAttribute('data-total-discount', cartTotalDiscount);
    cartSavingsMessage.querySelector('.column.savings-amount').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalDiscount, Simplistic.formatMoney)}</span>`;
  }

  if(orderLevelDiscountTotal > 0){
    let tieredDiscountMessage = document.querySelector(`${topSelector} .tiered_discount_message`);
    tieredDiscountMessage.innerHTML = `<p>${orderLevelDiscountMessage}</p>`;

    if(cartTotalContainer){
      cartTotalContainer.querySelector('.column.igSubtotal').setAttribute('data-tiered-discount', true);
    }
  }

  // Campaign-merchandized custom message under the cart total (side cart only).
  // When a campaign sets side_cart_custom_message_under_cart_total and at least one
  // cart item qualifies for that campaign, hide the tiered discount message and show
  // the merchandized message (with its merchandized text color) in its place.
  // Campaign 1 takes precedence over campaign 2.
  if(type == 'side-cart'){
    let cartProductHandles = Object.keys(perProductQuantities);
    let campaignCustomMessage = '';
    let campaignCustomMessageColor = '';
    for(let i = 1; i <= 2; i++){
      if(!discountCodeData[`active_campaign_${i}_is_active`]) continue;
      let customMessage = discountCodeData[`active_campaign_${i}_side_cart_custom_message`];
      if(!customMessage || customMessage === '') continue;
      let campaignHandles = (discountCodeData[`active_campaign_${i}_product_handles`] || '').replaceAll(' ', '').split(',');
      let aCartItemQualifies = cartProductHandles.some((handle) => campaignHandles.includes(handle));
      if(aCartItemQualifies){
        campaignCustomMessage = decodeURIComponent(customMessage.replace(/\+/g, ' '));
        campaignCustomMessageColor = discountCodeData[`active_campaign_${i}_side_cart_custom_message_color`] || '';
        break;
      }
    }

    let tieredDiscountMessageEl = document.querySelector(`${topSelector} .tiered_discount_message`);
    let customCartMessageEl = document.querySelector(`${topSelector} .campaign-custom-cart-message`);
    if(campaignCustomMessage !== ''){
      if(tieredDiscountMessageEl){ tieredDiscountMessageEl.style.display = 'none'; }
      if(!customCartMessageEl){
        customCartMessageEl = document.createElement('div');
        customCartMessageEl.classList.add('campaign-custom-cart-message');
        let anchor = tieredDiscountMessageEl || cartTotalContainer;
        if(anchor){ anchor.insertAdjacentElement('afterend', customCartMessageEl); }
      }
      customCartMessageEl.textContent = campaignCustomMessage;
      if(campaignCustomMessageColor !== ''){ customCartMessageEl.style.color = campaignCustomMessageColor; }
    } else {
      if(tieredDiscountMessageEl){ tieredDiscountMessageEl.style.display = ''; }
      if(customCartMessageEl){ customCartMessageEl.remove(); }
    }
  }

  return cartTotalDiscountedPrice;
}

window.Branch.functions.fireOnUserInteraction = function(callback, scrollContainerSelectorClass, el, argument, argument2) {
  const scrollContainer = scrollContainerSelectorClass && el && el.closest(`${scrollContainerSelectorClass}`)
    ? el.closest(`${scrollContainerSelectorClass}`)
    : null;

  const container = scrollContainer || window;

  function getScrollTop() {
    if (scrollContainer) return scrollContainer.scrollTop;
    return window.scrollY || document.documentElement.scrollTop;
  }

  function isElementVisibleInContainer(el) {
    const elRect = el.getBoundingClientRect();
    const containerRect = (scrollContainer || document.documentElement).getBoundingClientRect();

    return (
      elRect.bottom > containerRect.top &&
      elRect.top < containerRect.bottom
    );
  }

  const alreadyScrolled = getScrollTop() > 0;
  const isVisible = el && isElementVisibleInContainer(el);

  const interactionEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'pointerdown'];
  if (scrollContainer) {
    interactionEvents.push('scroll');
  } else {
    interactionEvents.push('scroll'); 
  }

  function onFirstUserInteraction() {
    interactionEvents.forEach(event => {
      if (event === 'scroll' && scrollContainer) {
        scrollContainer.removeEventListener(event, handleInteraction);
      } else {
        window.removeEventListener(event, handleInteraction);
      }
    });

    if (argument && argument2) {
      callback(argument, argument2);
    } else if (argument) {
      callback(argument);
    } else {
      callback();
    }
  }

  function handleInteraction() {
    onFirstUserInteraction();
  }

  if (alreadyScrolled || isVisible) {
    if (argument && argument2) {
      callback(argument, argument2);
    } else if (argument) {
      callback(argument);
    } else {
      callback();
    }
  } else {
    interactionEvents.forEach(event => {
      if (event === 'scroll' && scrollContainer) {
        scrollContainer.addEventListener(event, handleInteraction, { once: true });
      } else {
        window.addEventListener(event, handleInteraction, { once: true });
      }
    });
  }
};

window.Branch.functions.setupSwipeListener = function(element, callback, options = {}) {
  console.log('setupSwipeListener')
  const threshold = options.threshold ?? 50;
  const once = options.once ?? false; 

  let startX = 0;
  let startY = 0;
  let isTouch = false;

  function onStart(e) {
    isTouch = e.type === 'touchstart';
    const point = isTouch ? e.touches[0] : e;
    startX = point.clientX;
    startY = point.clientY;
  }

  function onEnd(e) {
    const point = isTouch ? e.changedTouches[0] : e;
    const deltaX = point.clientX - startX;
    const deltaY = point.clientY - startY;

    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
      const direction = deltaX > 0 ? 'right' : 'left';
      if (once) remove();
      callback(direction);
    }
  }

  function remove() {
    element.removeEventListener('mousedown', onStart);
    element.removeEventListener('mouseup', onEnd);
    element.removeEventListener('touchstart', onStart);
    element.removeEventListener('touchend', onEnd);
  }

  element.addEventListener('mousedown', onStart);
  element.addEventListener('mouseup', onEnd);
  element.addEventListener('touchstart', onStart);
  element.addEventListener('touchend', onEnd);

  return { remove };
}

window.Branch.functions.isScriptLoaded = function(src) {
  return Array.from(document.scripts).some(script => script.src === src);
}

isStylesheetLoaded = function(href) {
  return Array.from(document.styleSheets).some(sheet =>
    sheet.href === href
  );
}

window.Branch.functions.isHidden = function(el) {
  while (el) {
    const style = getComputedStyle(el);
    if (style.display === 'none') {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}

window.Branch.functions.checkSwiperNavVisibility = function(){
  const totalSlides = this.slides.length;
  const slidesPerView = this.params.slidesPerView;

  const prevEl = this.navigation.prevEl;
  const nextEl = this.navigation.nextEl;

  if (totalSlides <= slidesPerView) {
    prevEl.style.display = 'none';
    nextEl.style.display = 'none';
  } else {
    prevEl.style.display = '';
    nextEl.style.display = '';
  }
}

window.Branch.functions.saleTagUpdate = function(variantId, variantSwatchValue, originalPrice, currentPrice, product, type, fromBundleBuilder){
      let discountMessage = '';
      let savingsMessage = `Save ${Math.round(100 * ((originalPrice - currentPrice) / originalPrice))}%`;
      if(fromBundleBuilder){
        savingsMessage = `Save ${5 + Math.round(100 * ((originalPrice - currentPrice) / originalPrice))}%`;
      }

      if(originalPrice > currentPrice){
        discountMessage = savingsMessage;
      }

      if(type == "product"){
        if(document.querySelector(`#variant_metafield_values--${product.id}`)){
        const metafield_value = JSON.parse(document.querySelector(`#variant_metafield_values--${product.id}`).innerText)[`${variantId}`];

        let sales_tags = document.querySelectorAll(`.main-product-gallery[data-product-id="${ product.id }"] .sale`);
       
        if (metafield_value !== 'no_metafield_value'){
          discountMessage = metafield_value;
        } else if (sales_tags.length > 0 && sales_tags[0].getAttribute('data-mf-swatch-text') && sales_tags[0].getAttribute('data-mf-swatch-text') !== ""){
          discountMessage = sales_tags[0].getAttribute('data-mf-swatch-text');
        }

        if(discountCodeData.active_campaign_1_is_active && discountCodeData.active_campaign_1_product_handles.replaceAll(' ', '').split(",").includes(product.handle) && discountCodeData.active_campaign_1_amount != undefined && (discountCodeData.active_campaign_1_amount > 0 || discountCodeData.active_campaign_1_discount_type === 'No discount actually applied')){
          if(discountCodeData.discount_code_1_special_swatch_text && discountCodeData.discount_code_1_special_swatch_text != "" && fromBundleBuilder != true){
            discountMessage = `${discountCodeData.discount_code_1_special_swatch_text}`;
          } else if(!discountCodeData.active_campaign_1_disable_strike_through_pricing){
            discountMessage = savingsMessage;
          }
        } else if(discountCodeData.active_campaign_2_is_active && discountCodeData.active_campaign_2_product_handles.replaceAll(' ', '').split(",").includes(product.handle) && discountCodeData.active_campaign_2_amount != undefined && (discountCodeData.active_campaign_2_amount > 0 || discountCodeData.active_campaign_2_discount_type === 'No discount actually applied')){
          if(discountCodeData.discount_code_2_special_swatch_text && discountCodeData.discount_code_2_special_swatch_text != "" && fromBundleBuilder != true){
            discountMessage = `${discountCodeData.discount_code_2_special_swatch_text}`;
          } else if(!discountCodeData.active_campaign_2_disable_strike_through_pricing){
            discountMessage = savingsMessage;
          }
        }

        const shouldDisplaySale = discountMessage !== '' && !variantSwatchValue;

        if(shouldDisplaySale){
          sales_tags.forEach((sales_tag) => {
            sales_tag.innerText = discountMessage;
            sales_tag.classList.add('sale--display');
          })
        } else {
          sales_tags.forEach((sales_tag) => {
            sales_tag.innerText = '';
            sales_tag.classList.remove('sale--display');
          })
        }

        // Persist the resolved sale state onto the gallery element(s) so slides that are hydrated
        // later (see scripts_snippets_gallery-hydration.js) can build their .sale node already
        // populated, instead of emitting an empty one and relying on a re-run of saleTagUpdate.
        document.querySelectorAll(`.main-product-gallery[data-product-id="${ product.id }"]`).forEach((gallery) => {
          if(shouldDisplaySale){
            gallery.setAttribute('data-resolved-sale-text', discountMessage);
          } else {
            gallery.removeAttribute('data-resolved-sale-text');
          }
        });
      };
      } else {
        let sales_tag = document.querySelector(`.bundle-builder-gallery .pre-set-bundle-image-container + .sale`);
        if(sales_tag){
          let bundleProductPageData = document.querySelector('#preset-bundle-data') && document.querySelector('#preset-bundle-data').innerHTML ? JSON.parse(document.querySelector('#preset-bundle-data').innerHTML) : [];
          // Collect each campaign's Sale-swatch override (+ its promo styling) separately, then
          // resolve campaign-1 precedence below — so a campaign-2 constituent iterated first can't
          // mask a campaign-1 constituent's higher-precedence label.
          let campaign1Override = '', campaign2Override = '';
          let campaign1Promo = false, campaign2Promo = false;
          // Track whether any constituent qualifies for an active campaign at all (independent of the
          // Sale-swatch text override) so the bundle badge can take the campaign's swatch colours.
          let campaign1Qualifies = false, campaign2Qualifies = false;
          bundleProductPageData.forEach((bundleConstituent) => {
            if(discountCodeData.active_campaign_1_is_active && discountCodeData.active_campaign_1_product_handles.replaceAll(' ', '').split(",").includes(bundleConstituent.handle) && discountCodeData.active_campaign_1_amount != undefined && (discountCodeData.active_campaign_1_amount > 0 || discountCodeData.active_campaign_1_discount_type === 'No discount actually applied')){
              campaign1Qualifies = true;
              if(discountCodeData.discount_code_1_special_swatch_text != ""){
                if(campaign1Override === '') campaign1Override = discountCodeData.discount_code_1_special_swatch_text;
                campaign1Promo = discountCodeData.active_campaign_1_enable_promo_styling;
              }
            } else if(discountCodeData.active_campaign_2_is_active && discountCodeData.active_campaign_2_product_handles.replaceAll(' ', '').split(",").includes(bundleConstituent.handle) && discountCodeData.active_campaign_2_amount != undefined && (discountCodeData.active_campaign_2_amount > 0 || discountCodeData.active_campaign_2_discount_type === 'No discount actually applied')){
              campaign2Qualifies = true;
              if(discountCodeData.discount_code_2_special_swatch_text != ""){
                if(campaign2Override === '') campaign2Override = discountCodeData.discount_code_2_special_swatch_text;
                campaign2Promo = discountCodeData.active_campaign_2_enable_promo_styling;
              }
            }
          })
          // Campaign 1 always wins over campaign 2.
          let campaignOverrideMessage = campaign1Override || campaign2Override;
          // OR-in the personalization winner so the bundle sale badge gets the gradient even when the campaign's promo styling is off. See personalizations_trigger.liquid.
          let activeCampaignPromoStylingEnabled = (campaign1Override ? campaign1Promo : campaign2Promo) || (window.Branch.personalization && window.Branch.personalization.promoStylingWins);
          // Apply the campaign's swatch background colour whenever a constituent qualifies for a
          // campaign that defines one — independent of the promo-styling flag — so the bundle badge
          // matches the campaign colours shown on the constituents' own product tiles. Campaign 1
          // takes precedence over campaign 2.
          let applyCampaignSwatchBackground = false;
          if(campaign1Qualifies && discountCodeData.active_campaign_1_swatch_default_color){
            applyCampaignSwatchBackground = true;
          } else if(campaign2Qualifies && discountCodeData.active_campaign_2_swatch_default_color){
            applyCampaignSwatchBackground = true;
          }

          // On a preset bundle page, show the campaign's Sale-swatch label override (e.g.
          // "Save up to 18%") on the bundle's sale badge when a constituent qualifies, instead of
          // the price-derived "Save N%". Mirrors the per-product PDP behaviour above.
          sales_tag.innerText = (campaignOverrideMessage !== '' && fromBundleBuilder != true) ? campaignOverrideMessage : discountMessage;

          sales_tag.classList.add('sale--display');
          if(activeCampaignPromoStylingEnabled){
            sales_tag.setAttribute('active-campaign-promo-style', true);
            sales_tag.setAttribute('active-campaign-promo-type', 'discount_swatches');
          } else {
            sales_tag.removeAttribute('active-campaign-promo-style');
            sales_tag.removeAttribute('active-campaign-promo-type');
          }
          if(applyCampaignSwatchBackground){
            sales_tag.setAttribute('data-display-active-campaign-swatch-background', 'true');
          } else {
            sales_tag.removeAttribute('data-display-active-campaign-swatch-background');
          }

          const nearestGalleryItem = sales_tag.closest('.bundle-builder-gallery__item');

          if (nearestGalleryItem && sales_tag.closest('.bundle-builder-gallery__preset-loading-image')) {
            nearestGalleryItem.appendChild(sales_tag);
          }
        }
      }
    }

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

window.Branch.functions.isIOSSafari = function() {
  const ua = navigator.userAgent;
  const isIos = isIOS();
  const isWebkit = /WebKit/.test(ua);
  const isChrome = /CriOS/.test(ua);
  const isFirefox = /FxiOS/.test(ua);
  const isEdge = /EdgiOS/.test(ua);
  
  // iOS Safari is webkit-based but not Chrome/Firefox/Edge on iOS
  return isIos && isWebkit && !isChrome && !isFirefox && !isEdge;
}

window.Branch.functions.sortCompare = function(a,b){
    akey = parseInt($(a).attr("data-index"));
    bkey = parseInt($(b).attr("data-index"));
    if (akey == bkey) return 0;
    if (akey < bkey) return -1;
    if (akey > bkey) return 1;
};

// Function to trigger onVariantSelected without actually changing the variant
// Usage: window.Branch.functions.triggerVariantSelected(productId) or window.Branch.functions.triggerVariantSelected()
window.Branch.functions.triggerVariantSelected = function(productId) {
  // Option 1: If you have access to the product ID
  if (productId) {
    // Find the product JS instance for this product
  
    // Find the variant object
    var currentVariant = selected_main_product.selected_variant

    if (currentVariant) {

      console.log('currentVariant', currentVariant)
      // Call onVariantSelected directly
      // The selector parameter can be null as it's not always used
      if (window.productJs && window.productJs.onVariantSelected) {
        window.productJs.onVariantSelected(currentVariant, null);
      }

      console.log('Triggered onVariantSelected for variant:', currentVariant.id);
      return true;
    }   
  }

  console.error('Could not trigger onVariantSelected - variant or product data not found');
  return false;
};